<div [class]="(cmsData$ | async)?.styleClasses">
    <a [href]="(cmsData$ | async)?.url" target="_blank">
        {{ (cmsData$ | async)?.linkName }}
    </a>
</div>